import React from 'react';
import withIcon from '../utilities/withIcon';

const IconArrowIntegrate = () => {
  return (
    <g>
      <path d="m5.26 12.1213a4.1328 4.1328 0 1 1 4.2429-5.368l-.76-.4582a.65.65 0 0 0 -.6719 1.1133l2.06 1.2422a.6508.6508 0 0 0 .8926-.2207l1.2422-2.0591a.65.65 0 0 0 -1.1133-.6719l-.3274.5429a5.5316 5.5316 0 1 0 -5.6726 7.275c.0181.0015.0366.0024.0547.0024a.7.7 0 0 0 .0527-1.398z" />
      <path d="m10.894 2.4871a.7.7 0 0 0 -.1191 1.3945 4.1327 4.1327 0 1 1 -4.2899 5.3274l.783.4724a.65.65 0 0 0 .672-1.1133l-2.06-1.2422a.6506.6506 0 0 0 -.8926.2207l-1.2418 2.0591a.65.65 0 0 0 1.1133.6719l.3147-.5218a5.5316 5.5316 0 1 0 5.72-7.2687z" />
    </g>
  );
};

export default withIcon(IconArrowIntegrate);
